export const cognitoStatusMapping = (status: any) => {
    switch (status) {
        case 'CONFIRMED':
            return 'Confirmado';
        case 'FORCE_CHANGE_PASSWORD':
            return 'Mudança de senha forçada';
        default:
            return status;
    }
};


